import BaseRepository from "~/repositories/BaseRepository";
import UserAccountModel from "~/models/UserAccountModel";
import ImageGalleryModel from "~/models/ImageGalleryModel";

export default class UserAccountRepository extends BaseRepository {
  async show(userId: number): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = `/api/v1/user_accounts/${userId}`;
    const results = await this._get(url);
    return new UserAccountModel(results.data);
  }

  async imageGalleries(userIdHash: string): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const url = `/corporation/get_image_data_lists/${userIdHash}.json`;
    const result = await this._get(url);
    return result.data.map((val) => new ImageGalleryModel(val));
  }
}
